import axios from 'axios';
import { endpoints } from '../config/env';

const instance = axios.create({
  baseURL: endpoints.strapi,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const s3BucketInstance = axios.create({
  baseURL: endpoints.s3Bucket,
  headers: {
    'Content-Type': 'application/json'
  }
});

instance.interceptors.response.use((response) => response.data);
s3BucketInstance.interceptors.response.use((response) => response.data);

export default instance;
